import React from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
// import scannerImage from "../../assets/images/Scanner.jpg";
import scannerImage from "../../assets/images/AccountDetails.png";
import { ErrorMessage } from "@hookform/error-message";
import { ValidationMessage } from "../../utils/constants/validationMessage";
import { whiteSpaceCheck } from "../../helper/helper";

const Payment = ({
  setSelectedOption,
  selectedOption,
  errors,
  register,
  setValue,
  clearErrors,
  setError,
  watch,
}) => {
  const validateImageFile = (file) => {
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!file) return "Screenshot is required.";
    if (!allowedTypes.includes(file.type)) {
      return "Only JPEG, JPG, and PNG files are allowed.";
    }
    return true;
  };
  return (
    <div className="wrapper mw-100 position-relative mb-5 pb-2 px-md-4 px-3">
      <span className="wrapper-heading">Payment Module</span>
      <div className="mb-3 payment-module-sec">
        <Row className="justify-content-center">
          <Col md={6} lg={5} className="mb-2">
            <label className="card selection-card">
              <input
                className="form-check-input"
                type="radio"
                name="membership"
                id="threeYears"
                value="3Years"
                checked={selectedOption === "3Years"}
                onChange={(e) => setSelectedOption(e.target.value)}
              />
              <div className="card-body">
                <h5 className="card-title">3 Years Membership</h5>
                <p className="card-text">
                  Enjoy 3 years of exclusive benefits and perks in just 501 rs.
                </p>
              </div>
            </label>
          </Col>
          <Col md={6} lg={5}>
            <label className="card selection-card ">
              <input
                className="form-check-input"
                type="radio"
                name="membership"
                id="lifetime"
                value="Lifetime"
                checked={selectedOption === "Lifetime"}
                onChange={(e) => setSelectedOption(e.target.value)}
              />

              <div className="card-body">
                <h5 className="card-title">Lifetime Membership</h5>
                <p className="card-text">
                  Get lifetime access to all benefits and privileges in just
                  5001 rs.
                </p>
              </div>
            </label>
          </Col>
        </Row>
        <div className="d-flex justify-content-center align-items-center mt-4">
          <p className="text-center mb-0">
            You have selected{" "}
            {selectedOption === "Lifetime" ? (
              <strong style={{ color: "#ff6004" }}>Lifetime Membership</strong>
            ) : (
              <strong style={{ color: "#ff6004" }}>3 Years Membership</strong>
            )}
            .
          </p>
        </div>
        <hr
          style={{
            borderTop: "3px dashed #000",
            marginTop: "15px",
            marginBottom: "15px",
          }}
        />
      </div>
      <Row>
        <Col md={4} className="mb-3">
          <Form.Group className="" controlId="formReferencePerson">
            <Form.Label>Payment type</Form.Label>
            <Form.Select
              name="paymentType"
              {...register("paymentType", {
                required: ValidationMessage?.PAYMENT_TYPE_REQUIRED,
                validate: (value) => whiteSpaceCheck(value),
              })}
            >
              <option value="">Select payment type</option>
              <option value="cash">Cash</option>
              <option value="online">Online</option>
            </Form.Select>

            <ErrorMessage
              errors={errors}
              name="paymentType"
              render={({ message }) => (
                <p className="error-message text-start py-2 px-1 text-danger">
                  {message}
                </p>
              )}
            />
          </Form.Group>
        </Col>
        {watch("paymentType") === "online" && (
          <>
            <Col md={4} className="mb-3">
              <Form.Group className="" controlId="formReferencePerson">
                <Form.Label>Payment method</Form.Label>
                <Form.Select
                  name="paymentMethod"
                  {...register("paymentMethod", {
                    required: ValidationMessage?.PAYMENT_METHOD_REQUIRED,
                    validate: (value) => whiteSpaceCheck(value),
                  })}
                >
                  <option value="">Select payment type</option>
                  <option value="googlepay">Google pay</option>
                  <option value="phonepe">Phone pay</option>
                  <option value="paytm">PayTM</option>
                  <option value="net-banking">Net Banking</option>
                </Form.Select>

                <ErrorMessage
                  errors={errors}
                  name="paymentMethod"
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
            <Col md={4} className="mb-3">
              <Form.Group controlId="formUploadScreenshot">
                <Form.Label>Upload Screenshot</Form.Label>
                <Form.Control
                  type="file"
                  accept=".jpg,.jpeg,.png"
                  {...register("screenshot", {
                    validate: (fileList) => {
                      const file = fileList[0];
                      const allowedTypes = [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                      ];
                      if (!file) return "Screenshot is required.";
                      if (!allowedTypes.includes(file.type)) {
                        return "Only JPEG, JPG, and PNG files are allowed.";
                      }
                      return true;
                    },
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="screenshot"
                  render={({ message }) => (
                    <p className="error-message text-start py-2 px-1 text-danger">
                      {message}
                    </p>
                  )}
                />
              </Form.Group>
            </Col>
          </>
        )}
        {selectedOption && watch("paymentType") === "online" && (
          <div className="d-flex justify-content-center align-item-center w-100">
            <Col md={12} lg={8}>
              <div className="payment-qr-code">
                <div className="payment-module-sec p-3">
                  <Row className="justify-content-center mx-0">
                    <Col xs={12} className="mb-3 px-0">
                      <div className="card selection-card text-center p-4 shadow-sm">
                        <h5
                          className="mb-3 fw-bold"
                          style={{ color: "#ff6004" }}
                        >
                          सरयूपारीण ब्राह्मण समाज, राजस्थान
                        </h5>
                        <p className="mb-2 fw-bold">
                          खाता नंबर : 14630100011515
                        </p>
                        <p className="mb-2 fw-bold">
                          बैंक ऑफ बड़ौदा, उद्योग भवन शाखा, जयपुर
                        </p>
                        <p className="mb-2 fw-bold">
                          आईएफएससी कोड : BARB0JAICOM
                        </p>
                        <p className="text-muted fw-bold">
                          (Fifth Character Is Zero)
                        </p>
                      </div>
                    </Col>
                  </Row>
                  {/* <img src={scannerImage} alt="Scan QR Code" className="m-auto mt-3 img-fluid" /> */}
                </div>
              </div>
            </Col>
          </div>
        )}
      </Row>
    </div>
  );
};

export default Payment;
